import React from 'react'

type FinalCtaCopy = {
  finalTitle: string
  finalCopy: string
  finalCta: string
}

type FinalCtaSectionProps = {
  copy: FinalCtaCopy
  appHref: string
}

export const FinalCtaSection: React.FC<FinalCtaSectionProps> = ({ copy, appHref }) => {
  return (
    <section className="landing-final">
      <div className="container landing-final__inner">
        <h2>{copy.finalTitle}</h2>
        <p>{copy.finalCopy}</p>
        <a className="btn btn-primary" href={appHref}>{copy.finalCta}</a>
      </div>
    </section>
  )
}
